module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AwFDAkNjteSgQAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAABRSURBVDjLY2AYBYwfox3/k6uZf+l+RkYGBgYGcgzhX7qfkYGBgYERJkCKITDNKAYQawiyZgwDCBmCrhmrAbgMwaYZpwHohuDSTBBQEsUjCQAA/ZYelGyxXDoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/stats/container/shop/tile/down.png
// module id = 904
// module chunks = 0